import api from "@/api.js";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    siteData: {},
    fullLoading: true,
    dateRange: [],
    navigationDrawer: true,
    siteSettings: {},
    offlineMode: false,
    appID: {},
    apiUrl: "",
    miniNavState: false,
    siteCFG: {
      fields: {
        general: {
          filled: false,
          outlined: true,
          borderless: false,
          standout: false,
          "hide-bottom-space": false,
          rounded: false,
          square: false,
          dense: false
        }
      }
    },
    disableVirtualScrolling: false,
    userRoles: [
      "Admin",
      "Sport Manager",
      "Waves Manager",
      "Official",
      "Club Admin",
      "Team Manager",
      "Coach",
      "Sports Coordinator",
      "Junior Coordinator"
      // "Athlete"
    ],
    associationUserRoles: [],
    darkMode: false,
    competitionTypes: [
      {
        label: "Beach",
        value: "BEACH"
      },
      {
        label: "Pool",
        value: "POOL"
      }
    ],
    genderTypes: [
      {
        label: "Male",
        value: "M"
      },
      {
        label: "Female",
        value: "F"
      },
      {
        label: "Mixed",
        value: "X"
      }
    ],
    disciplineTypes: [],
    disciplineTypesLoading: true,
    disciplineSports: [
      {
        label: "SLS",
        value: "SLS"
      },
      {
        label: "Swim",
        value: "SWIM"
      },
      {
        label: "Pool",
        value: "SLS_POOL"
      }
    ],
    eventSLGAwardList: [
      {
        label: "Yes",
        value: 1
      },
      {
        label: "Masters",
        value: 2
      },
      {
        label: "No",
        value: 3
      }
    ],
    namingFormatsList: [],
    teamNamingFormatsList: [],
    poolLengthOptions: [
      {
        label: "--",
        value: "--"
      },
      {
        label: "25m",
        value: "25m"
      },
      {
        label: "50m",
        value: "50m"
      }
    ],
    competitionStatusOptions: [
      {
        label: "Draft",
        value: "DRAFT"
      },
      {
        label: "Live",
        value: "LIVE"
      },
      {
        label: "Archived",
        value: "ARCHIVED"
      }
    ],
    questionTypes: [
      {
        label: "Coach Contacts",
        value: 0
      },
      {
        label: "Manager Contacts",
        value: 1
      },
      {
        label: "Other Contacts",
        value: 2
      },
      {
        label: "Official Contact",
        value: 3
      }
    ],
    questionRangeOptions: [
      {
        label: "No Range Rule",
        value: 0,
        jsValue: null
      },
      {
        label: "Per 10",
        value: 2
      }
    ],
    questionRangeTypes: [
      {
        label: "Range Rule",
        value: 0
      },
      {
        label: "Min and Max",
        value: 1
      }
    ],
    competitionLimitTypes: ["All", "All Added", "All CRM", "Specific"],
    siteArea: "Design",

    // DQ Codes
    dqCodes: ["DQ", "DNS", "DNF", "DNR"],
    dqTypes: [{}],

    // User Permissions
    userPermissionTypeOptions: [],
    userPermissionRoleOptions: {}
  },
  mutations: {
    setSiteData(state, payload) {
      state.siteData = payload;
    },
    setDisableVirtualScrolling(state, payload) {
      state.disableVirtualScrolling = payload
    },
    setFullLoader(state, loading) {
      state.fullLoading = loading;
    },
    setDateRange(state, date) {
      state.dateRange = date;
    },
    setNavigationDrawer(state, drawer) {
      state.navigationDrawer = drawer;
    },
    setOfflineMode(state, mode) {
      state.offlineMode = mode;
    },
    setSelectedRowData(state, rowData) {
      state.selectedRowData = rowData;
    },
    setAppID(state, id) {
      state.appID = id;
    },
    setApiUrl(state, apiUrl) {
      state.apiUrl = apiUrl;
    },
    setMiniNavState(state, payload) {
      state.miniNavState = payload;
    },
    setConfig(state, payload) {
      state.siteCFG = payload;
    },
    setDarkMode(state, payload) {
      state.darkMode = payload;
    },
    setUserRoles(state, payload) {
      state.userRoles = payload;
    },
    setAssociationUserRoles(state, payload) {
      state.associationUserRoles = payload;
    },
    setDisciplineTypes(state, payload) {
      state.disciplineTypes = payload;
    },
    setDisciplineTypesLoading(state, payload) {
      state.disciplineTypesLoading = payload;
    },
    setQuestionRangeOptions(state, payload) {
      state.questionRangeOptions = payload;
    },
    setQuestionRangeTypes(state, payload) {
      state.questionRangeTypes = payload;
    },
    setSiteArea(state, payload) {
      state.siteArea = payload;
    },
    setDQTypes(state, payload) {
      state.dqTypes = payload;
    },
    setDQTypesLoading(state, payload) {
      state.dqTypesLoading = payload;
    },
    setNamingFormatList(state, payload) {
      state.namingFormatsList = payload;
    },
    setTeamNamingFormatList(state, payload) {
      state.teamNamingFormatsList = payload;
    },
    setUserPermissionTypeOptions(state, payload) {
      state.userPermissionTypeOptions = payload;
    },
    setUserPermissionRoleOptions(state, payload) {
      state.userPermissionRoleOptions = payload;
    },
    setCompetitionStatusOptions(state, payload) {
      state.competitionStatusOptions = payload;
    },
    setPoolLengthOptions(state, payload) {
      state.poolLengthOptions = payload;
    }
  },
  actions: {
    async loadSiteData({ commit }) {
      // let siteData = await api.get("applications/siteData");
      // commit("setSiteData", siteData.data);
      // document.title = siteData.data.name;
      // let baseUrl = "https://api.Waves App.com";
      // let host = window.location.host;
      // if (
      //   host == "localhost:8080" ||
      //   host == "localhost:8081" ||
      //   host == "localhost:8082" ||
      //   host == "192.168.178.21:8080" ||
      //   host == "192.168.178.21:8081" ||
      //   host == "192.168.178.21:8082" ||
      //   host == "10.0.0.9:8080"
      // ) {
      //   baseUrl = "http://localhost:32775";
      // } else if (host == "wavesapp.firebaseapp.com") {
      //   baseUrl = "https://Waves App-api.simplesoft.nz";
      // } else if (host.substring(0, 4) == "dev.") {
      //   baseUrl = "https://Waves App-api.simplesoft.nz";
      // }
      // commit("setApiUrl", baseUrl);
    },
    checkOnlineStatus({ commit }) {
      commit("setOfflineMode", !navigator.onLine);
    },
    setFullLoaderState({ commit }, loading) {
      commit("setFullLoader", loading);
    },
    async setNavigationDrawerState({ commit }, payload) {
      commit("setNavigationDrawer", payload);
    },

    async loadDateRange({ commit, dispatch }, payload) {
      commit("setDateRange", payload);
      dispatch("events/loadAll", null, { root: true });
    },
    async loadDefaultDateRange({ commit }) {
      commit("setDateRange", {
        to: `${moment().format("YYYY/MM/DD")}`,
        from: `${moment()
          .day(-7)
          .format("YYYY/MM/DD")}`
      });
    },
    async getAppID({ commit }) {
      if (
        window.location.host == "wavesapp.firebaseapp.com" ||
        window.location.host == "localhost:8080" ||
        window.location.host == "192.168.178.21:8080"
      ) {
        commit("setAppID", 0);
      }
    },
    randomString({ commit }, payload) {
      var mask = "";
      if (payload.chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz";
      if (payload.chars.indexOf("A") > -1) mask += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      if (payload.chars.indexOf("#") > -1) mask += "0123456789";
      if (payload.chars.indexOf("!") > -1)
        mask += "~`!@#$%^&*()_+-={}[]:\";'<>?,./|\\";
      var result = "";
      for (var i = payload.len; i > 0; --i)
        result += mask[Math.floor(Math.random() * mask.length)];
      return result;
    },
    togglMiniNav({ commit, state }) {
      commit("setMiniNavState", !state.miniNavState);
    },
    updateConfig({ commit }, payload) {
      commit("setConfig", payload);
    },
    changeDarkMode({ commit }, payload) {
      commit("setDarkMode", payload);
    },
    updateValues({ commit }) {
      commit("setUserRoles", [
        "Admin",
        "Sport Manager",
        "Club Admin",
        "Team Manager",
        "Waves Manager",
        "Coach",
        "Official",
        "Sports Coordinator",
        "Junior Coordinator"
        // "Athlete"
      ]);
      commit("setPoolLengthOptions", [
        {
          label: "--",
          value: "--"
        },
        {
          label: "25m",
          value: "25m"
        },
        {
          label: "33m",
          value: "33m"
        },
        {
          label: "50m",
          value: "50m"
        }
      ]);
      commit("setAssociationUserRoles", [
        "Club Admin",
        "Team Manager",
        "Coach",
        "Official",
        "Sports Coordinator",
        "Junior Coordinator"
        // "Athlete"
      ]);
      commit("setQuestionRangeOptions", [
        {
          label: "No Range Rule",
          value: 0,
          jsValue: null
        },
        {
          label: "Per 10",
          value: 2
        }
      ]);
      commit("setQuestionRangeTypes", [
        {
          label: "Range Rule",
          value: 0
        },
        {
          label: "Min and Max",
          value: 1
        }
      ]);
      commit("setNamingFormatList", [
        {
          label: 'Players First name Last Initial (eg. "Ron W, Harry P")',
          value: 6
        },
        {
          label: 'Players First Initial Last Name (eg. "R Weasley, H Potter")',
          value: 7
        },
        {
          label: 'Players LAST NAME, First name (eg. "WEASLEY, Ron")',
          value: 8
        }
      ]);
      commit("setTeamNamingFormatList", [
        {
          label: 'User Editable (eg. "Any Team Name")',
          value: 1
        },
        {
          label: 'User Editable Suffix (eg. Club Name "Sharks")',
          value: 2
        },
        {
          label: "No Suffix (eg. Club Name)",
          value: 3
        },
        {
          label: 'Numeric Suffix 1, 2, 3 (eg. Club Name "1")',
          value: 4
        },
        {
          label: 'Alpha Suffix A,B,C(eg. Club Name "A")',
          value: 5
        }
      ]);
      commit("setUserPermissionTypeOptions", [
        { label: "Admin", value: "Admin" },
        { label: "Association", value: "Association" }
      ]);
      commit("setUserPermissionRoleOptions", {
        Admin: [
          {
            label: "Admin",
            value: "Admin"
          },
          {
            label: "Sport Manager",
            value: "Sport Manager"
          },
          {
            label: "Waves Manager",
            value: "Waves Manager"
          },
          {
            label: "Official",
            value: "Official"
          }
        ],
        Association: [
          {
            label: "Club Admin",
            value: "Club Admin"
          },
          {
            label: "Team Manager",
            value: "Team Manager"
          },
          {
            label: "Coach",
            value: "Coach"
          },
          {
            label: "Sports Coordinator",
            value: "Sports Coordinator"
          },
          {
            label: "Junior Coordinator",
            value: "Junior Coordinator"
          }
          // {
          //   label: "Athlete",
          //   value: "Athlete"
          // }
        ]
      });
      commit("setCompetitionStatusOptions", [
        {
          label: "Draft",
          value: "DRAFT"
        },
        {
          label: "Live",
          value: "LIVE"
        },
        {
          label: "Archived",
          value: "ARCHIVED"
        }
      ]);

      // commit("setDQTypes", {
      //   DQ: ["Boats/Canoes", "IRB", "Beach", "Ocean", "Pool"],
      //   DNS: [
      //     "Conditions",
      //     "Injury",
      //     "Unsafe",
      //     "Equipment Failure",
      //     "Programme Clash"
      //   ],
      //   DNF: ["Conditions", "Injury", "Unsafe", "Equipment Failure"]
      // });
    },
    async loadDisciplineTypes({ commit }) {
      commit("setDisciplineTypesLoading", true);
      let list = await api.get("disciplines/loadTypes");
      let types = [];
      list.data.forEach(type => {
        if (type.type) {
          types.push(type.type);
        }
      });
      commit("setDisciplineTypes", types);
      commit("setDisciplineTypesLoading", false);
    },
    async loadDQTypes({ commit }) {
      let list = await api.get("dqCodes/loadTypes");
      commit("setDQTypes", list.data);
    },
    async changeSiteArea({ commit }, payload) {
      commit("setSiteArea", payload);
    },
    toggleVirtualScrolling({ commit, state }, payload) {
      commit("setDisableVirtualScrolling", !state.disableVirtualScrolling);
    }

  },
  getters: {
    siteData(state) {
      return state.siteData;
    },
    dateRange(state) {
      return state.dateRange;
    },
    fullLoading(state) {
      return state.fullLoading;
    },
    navigationDrawer(state) {
      return state.navigationDrawer;
    },
    offlineMode(state) {
      return state.offlineMode;
    },
    apiUrl(state) {
      return state.apiUrl;
    },
    miniNavState(state) {
      return state.miniNavState;
    },
    siteCFG(state) {
      return state.siteCFG;
    },
    userRoles(state) {
      return state.userRoles;
    },
    darkMode(state) {
      return state.darkMode;
    },
    competitionTypes(state) {
      return state.competitionTypes;
    },
    genderTypes(state) {
      return state.genderTypes;
    },
    disciplineTypes(state) {
      return state.disciplineTypes;
    },
    disciplineTypesLoading(state) {
      return state.disciplineTypesLoading;
    },
    disciplineSports(state) {
      return state.disciplineSports;
    },
    eventSLGAwardList(state) {
      return state.eventSLGAwardList;
    },
    namingFormatsList(state) {
      return state.namingFormatsList;
    },
    teamNamingFormatsList(state) {
      return state.teamNamingFormatsList;
    },
    poolLengthOptions(state) {
      return state.poolLengthOptions;
    },
    competitionStatusOptions(state) {
      return state.competitionStatusOptions;
    },
    associationUserRoles(state) {
      return state.associationUserRoles;
    },
    questionTypes(state) {
      return state.questionTypes;
    },
    questionRangeOptions(state) {
      return state.questionRangeOptions;
    },
    questionRangeTypes(state) {
      return state.questionRangeTypes;
    },
    competitionLimitTypes(state) {
      return state.competitionLimitTypes;
    },
    siteArea(state) {
      return state.siteArea;
    },
    dqTypes(state) {
      return state.dqTypes;
    },
    dqCodes(state) {
      return state.dqCodes;
    },
    userPermissionTypeOptions(state) {
      return state.userPermissionTypeOptions;
    },
    userPermissionRoleOptions(state) {
      return state.userPermissionRoleOptions;
    },
    disableVirtualScrolling(state) {
      return state.disableVirtualScrolling;
    },
    availableSeasons() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear() + 1;
      const currentMonth = currentDate.getMonth() + 1; // January is 0, so we add 1 to get the correct month.

      let startYear = 2022;

      let numYearsAhead = currentYear - 2022;

      if (currentMonth >= 7) {
        numYearsAhead = numYearsAhead + 1;
      }

      const seasons = [];

      for (let i = 0; i < numYearsAhead; i++) {
        seasons.push(`${startYear}-${(startYear + 1).toString()}`);
        startYear++;
      }
      return seasons;
    }


  }
};
